// extracted by mini-css-extract-plugin
module.exports = {"schedule":"QuickBookingRestShortB_schedule__DmZdc","selector":"QuickBookingRestShortB_selector__K_k8K","buttons":"QuickBookingRestShortB_buttons__9Mq4B"};